export const CALC_API_DEBOUNCE_DURATION = 500;

export const DATA_STORAGE_KEY = 'GRAWE:react:forms:online-payment:data';
export const PAYMENT_STORAGE_KEY = 'GRAWE:react:forms:online-payment:payment';

export const DATE_ERROR_MESSAGES = {
  min14years: 'Versicherter muss mindestens das 14. Lebensjahr vollendet haben.',
  inFuture: 'Eingegebenes Datum muss in der Vergangenheit liegen!'
};
